"use client";

import { FC } from "react";
import { cn } from "utils";

interface ProfileSettingsCardProps {
  children: React.ReactNode;
  className?: string;
}

export const ProfileSettingsCard: FC<ProfileSettingsCardProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        "rounded-3 bg-background_solid_neutral_primary overflow-hidden divide-y divide-border_inverse_transparent10",
        className,
      )}
    >
      {children}
    </div>
  );
};
